import axios from 'axios';
import {UTIL_SERVICE} from "./utils";
import {ERROR_500} from "./urlConfig";
let qs = require('qs');

let requestServiceFactory = {};
let vs = true;
let last500 = null;

if (vs) {
// Interceptor
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response.status === 500) {
      try {
        if (last500 !== error.response.request.responseURL) {
          last500 = error.response.request.responseURL;

          axios.post(ERROR_500, {
            LogErrorFromWhere: 1,
            companyId: JSON.parse(window.localStorage.getItem('userInfo')).companyId,
            methodName: error.response.request.responseURL,
            exception: error.response.data.stackTrace,
            message: error.response.config.data
          }, { headers: HEADER()});
        }
      } catch (e) {

      }
    }

    if (error.response.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
      return
    }

    UTIL_SERVICE.showErrorsInDev(error.response.request.responseURL, error.response.data, error.response.status, error.response.config.data);

    return Promise.reject(error);
  });

// HEADER CONFIG
  let HEADER = function () {
    let authUser = JSON.parse(window.localStorage.getItem('authUser'));
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    let browserId = JSON.parse(window.localStorage.getItem('browserId'));

    let headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    if (userInfo) {
      if (userInfo.id && userInfo.companyId) {
        headers.Up = userInfo.id + userInfo.companyId;
        headers.uId = userInfo.id;
        headers.cId = userInfo.companyId;
        headers.companyId = userInfo.companyId;
      }
    }

    if (browserId) {
      headers.DeviceId = browserId;
    }

    if (authUser) {
      if (authUser.userToken && authUser.isAuth) {
        headers.Authorization = 'Bearer ' + authUser.userToken;
      }

      if (authUser.userContentSetting && authUser.isAuth) {
        headers.Contentsetting = authUser.userContentSetting;
      }
    }

    if (userInfo)
      if (userInfo.id && userInfo.companyId) {
        headers.Up = userInfo.id + userInfo.companyId;
      }

    return headers
  };

// LOGIN
  let _login = (url, data, browserId) => {
    let loginHeader = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    return axios.post(url, qs.stringify({
      password: data.password,
      username: data.email,
      grant_type: 'password',
      client_id: '099153c2625149bc8ecb3e85e03f0022',
      deviceModelCode: 'web_id:' + browserId
    }), loginHeader);
  };

// GET Full address from CEP
  let _fullAddress = (cep) => {
    let url = "https://ddd.pricez.com.br/cep/" + cep + ".json";
    return axios.get(url);
  };

// GET
  let _get = (url) => {
    return axios.get(url, { headers: HEADER()});
  };

// POST
  let _post = (url, data) => {
    return axios.post(url, data, { headers: HEADER()});
  };

// PUT
  let _put = (url, data) => {
    return axios.put(url, data, { headers: HEADER()});
  };

// PATCH
  let _patch = (url, data) => {
    return axios.patch(url, data, { headers: HEADER()});
  };

// DELETE
  let _delete = (url) => {
    return axios.delete(url, { headers: HEADER()});
  };

// LOGOUT
  let _logout = () => {
    return new Promise(function(resolve, reject) {
      try {
        window.localStorage.removeItem('checkFirstRequestDay');
        window.localStorage.removeItem('configMenu');
        window.localStorage.removeItem('authUser');
        window.localStorage.removeItem('userInfo');
        window.localStorage.removeItem('modePin');
        window.localStorage.removeItem('userAccess');
        window.localStorage.removeItem('checkRequest');

        resolve("Success");
      } catch (err) {
        reject(err);
      }
    });
  };

// UPLOAD FILE
  let _fileUpload = (url, file) => {
    let authUser = JSON.parse(window.localStorage.getItem('authUser'));
    let fd = new FormData();

    let header = {
      headers: {
        'Content-Type': undefined
      }
    };

    if (authUser) {
      if (authUser.userToken && authUser.isAuth) {
        header.Authorization = 'Bearer ' + authUser.userToken;  
      }

      if (authUser.userContentSetting && authUser.isAuth) {
        header.Contentsetting = authUser.userContentSetting;
      }
    }

    fd.append('file', file);

    return axios.post(url, fd, { headers: header});
  };

// GET FILE
  let _getFile = (url, checkAuth) => {
    let request = {
      method: 'GET',
      url: url,
      params: { name: name },
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };

    if (checkAuth) {
      let authUser = JSON.parse(window.localStorage.getItem('authUser'));

      if (authUser.userToken && authUser.isAuth) {
        request.headers.Authorization = 'Bearer ' + authUser.userToken;
      }
    }

    return axios(request);
  };

// CUSTOM
  let _customRequest = (method, url, data, header) => {
    let request = {
      method: method,
      url: url
    };

    if (method !== "GET")
      if (data)
        request.data = data;

    console.log(header, "  request request REQUEST")

    return axios(request, { headers: HEADER()});
  };


  requestServiceFactory.login = _login;
  requestServiceFactory.logout = _logout;
  requestServiceFactory.get = _get;
  requestServiceFactory.post = _post;
  requestServiceFactory.put = _put;
  requestServiceFactory.patch = _patch;
  requestServiceFactory.delete = _delete;
  requestServiceFactory.fileUpload = _fileUpload;
  requestServiceFactory.getFile = _getFile;
  requestServiceFactory.customRequest = _customRequest;
  requestServiceFactory.fullAddress = _fullAddress;
}

export const REQUEST_SERVICE = requestServiceFactory;




// WEBPACK FOOTER //
// ./src/requestConfig.js